import { type UIConfig } from '../../../types';

export const initialState: UIConfig = {
	fullScreen: false,
	externalEmbed: false,
	isContextPanelEnabled: false,
	customHandlers: {
		handleDeepLinkClick: undefined,
		handleSubmitSmartCreate: () => {},
	},
	isBitbucketBetaEnabled: false,
	customFeedbackCategories: undefined,
	stagingAreaRef: undefined,
	promptInputDroppableUrls: undefined,
	enableBrowserContextBanner: false,
	disableSettingsModal: false,
	enableSkills: true,
	enableAutoSuggest: true,
	enableMiniModalResize: true,
	browserContextSanitizer: undefined,
	elements: {
		closeButton: true,
		newChatButton: true,
		fullscreenButton: true,
		createAgentButton: true,
		browseAgentsButton: true,
		agentsMenu: true,
		navbar: true,
		mainChatHeader: true,
		stagingAreaEnabled: false,
		voiceDictationButton: false,
		fileUploadButton: true,
		chatModeMenuButton: true,
		maxModeButton: true,
		shouldShowConversationActions: true,
		shouldShowContextBanner: true,
	},
};
